export default {
    application: {
        contract: "期权分析",
        stock: "股票分析",
        more: "更多工具",
    },

    page_title_suffix: " - 期权分析助手",

    contract: {
        title: "期权分析助手",
        keywords: "FSF期权实验室",
        description: "期权分析助手",

        overview: "总览",
        realtime: "实时T阵",
        history: "归档分析",
        analyze: "合约洞察",
        anomaly: "异动监测",
        strategy: "策略中心",
        intelligence: "智能报告",
        calc: "期权计算器",
    },
};
